// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"MainNav_chromeframe__fh7WL","top":"MainNav_top__1KFuq","bottom":"MainNav_bottom__1W0IE","button":"MainNav_button__3TjCU"};